module.exports = __webpack_public_path__ + "img/logo-sepet_512x512.d8eae7c0.png";